<div
  class="w-full h-auto py-[13rem] max-lg:py-[8rem]"
  [class]="bgColor()">
  <div class="page-content-padding page-content-max-width w-full flex max-lg:flex-col gap-20">
    <div class="flex-[1.5_1.5_0] h-full flex flex-col justify-center items-start">
      <h1
        class="text-black text-balance text-[92px] leading-[92px] max-xl:text-[64px] max-xl:leading-[64px] max-lg:text-[44px] max-lg:leading-[44px] mb-10">
        {{ label() }}
      </h1>
      <div
        [class]="descColor()"
        class="text-night lg:text-xl">
        <ng-content select="[description]"></ng-content>
      </div>
    </div>
    <div class="h-full flex-1 flex justify-end self-center max-lg:self-start">
      <ng-content select="[link]"></ng-content>
    </div>
  </div>
</div>
